// extracted by mini-css-extract-plugin
module.exports = {"St1":"SupportIcon_St1___MofX","St2":"SupportIcon_St2__GHo88","St0":"SupportIcon_St0__LvChX","Hovered":"SupportIcon_Hovered__p_Mez"};